import companyProfile from '@/api/company-profile'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return companyProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return companyProfile.store(data)
  },

  update(context, data) {
    return companyProfile.update(data)
  },

  delete(context, id) {
    return companyProfile.destroy(id)
  },

  uploadLogo(context, data) {
    return companyProfile.storelogo(data)
  },

  getLogo(context, company_id) {
    return companyProfile.getlogo(company_id)
  }
}
